webpackJsonp([107818501498521],{

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _glamorous = __webpack_require__(30);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(10);
	
	var _typography = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var blogContainer = (0, _glamor.css)({
	  display: 'grid',
	  gridTemplateColumns: 'repeat(12, 8%)',
	  gridTemplateRows: 'auto',
	  width: '100%',
	  justifyContent: 'space-evenly'
	});
	
	var blogArticle = (0, _glamor.css)({
	  gridColumnStart: 3,
	  gridColumnEnd: 11,
	  '@media (max-width: 768px)': {
	    gridColumnStart: 1,
	    gridColumnEnd: 13
	  }
	});
	
	var blogPostTitle = (0, _glamor.css)({
	  '@media (max-width: 768px)': {
	    fontSize: (0, _typography.rhythm)(1),
	    marginTop: (0, _typography.rhythm)(1),
	    marginBottom: 0
	  }
	});
	
	var blogPostDate = (0, _glamor.css)({
	  fontSize: (0, _typography.rhythm)(0.75),
	  marginTop: (0, _typography.rhythm)(1),
	  marginBottom: (0, _typography.rhythm)(1),
	  '@media (max-width: 768px)': {
	    fontSize: (0, _typography.rhythm)(0.5),
	    marginTop: (0, _typography.rhythm)(0.5),
	    marginBottom: (0, _typography.rhythm)(1)
	  }
	});
	
	var blogPostContent = (0, _glamor.css)({
	  width: '100%',
	  '> pre': {
	    color: '#4b4',
	    background: '#000',
	    padding: '4px 6px',
	    fontSize: (0, _typography.rhythm)(0.2),
	    lineHeight: 1.4
	  },
	  '@media (max-width: 768px)': {
	    '> pre': {
	      fontSize: (0, _typography.rhythm)(0.1),
	      lineHeight: 1.1,
	      borderTop: '1px solid #888',
	      borderBottom: '1px solid #888',
	      padding: '2px',
	      overflow: 'visible'
	    }
	  }
	});
	
	function Template(_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  return Glamor.createElement(
	    'div',
	    { className: blogContainer },
	    Glamor.createElement(
	      _reactHelmet2.default,
	      null,
	      Glamor.createElement(
	        'title',
	        null,
	        post.frontmatter.title
	      ),
	      Glamor.createElement('meta', {
	        name: 'description',
	        content: post.frontmatter.excerpt ? post.frontmatter.excerpt : post.excerpt
	      }),
	      Glamor.createElement('meta', { name: 'og:description', content: post.excerpt }),
	      Glamor.createElement('meta', { name: 'twitter:description', content: post.excerpt }),
	      Glamor.createElement('meta', { name: 'og:title', content: post.frontmatter.title })
	    ),
	    Glamor.createElement(
	      'article',
	      { className: blogArticle },
	      Glamor.createElement(
	        'header',
	        null,
	        Glamor.createElement(
	          'h1',
	          { className: blogPostTitle },
	          post.frontmatter.title
	        ),
	        Glamor.createElement(
	          'h2',
	          { className: blogPostDate },
	          post.frontmatter.date
	        )
	      ),
	      Glamor.createElement(
	        'section',
	        null,
	        Glamor.createElement('div', {
	          className: blogPostContent,
	          dangerouslySetInnerHTML: { __html: post.html }
	        })
	      )
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-cd4d10f5a42e52819447.js